import { useEffect, useState } from "react";
import { ResponsiveContainer } from "recharts";

/* Retarde le rendu du graphique d'une frame : le conteneur parent est alors
   mesuré, ce qui supprime le warning Recharts "width(-1) and height(-1)". */
export function SafeChart({ children, ...props }) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const id = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(id);
  }, []);
  if (!ready) return <div style={{ width: "100%", height: "100%" }} />;
  return <ResponsiveContainer {...props}>{children}</ResponsiveContainer>;
}
